import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';
import { NgClass } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';
import { ButtonComponent } from '../buttons/button/button.component';

@Component({
  selector: 'mwe-special-alert',
  templateUrl: './special-alert.component.html',
  imports: [NgClass, ButtonComponent, TranslatePipe],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SpecialAlertComponent {
  titleKey = input<string>();
  messageKey = input<string>();
  reloadButtonKey = input<string>();
  showReloadLoadingSpinner = input<boolean>(false);
  noShadow = input<boolean>(false);
  readonly reloadEventEmitter = output<any>();

  showTitle = computed(() => {
    return this.titleKey()?.length > 0;
  });
}
